import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button, Modal, notification, Space } from "antd";
import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";

import { Case } from "@/root/models/case";
import { CasesApi } from "@/api/client/cases";
import { UserTypeEnum } from "@/root/types";
import { useAppSelector } from "@/hooks/redux";

const { confirm } = Modal;

interface CasesTableActionsProps {
  medCase: Case;
  onWatchClick: (medCase: Case) => void;
  onDelete: (id: string) => void;
  onEditButtonClick: (medCase: Case) => void;
}

const CasesTableActions = ({
  medCase,
  onWatchClick,
  onDelete,
  onEditButtonClick,
}: CasesTableActionsProps) => {
  const { t } = useTranslation();
  const [deleteLoading, setDeleteLoading] = useState(false);
  const userType = useAppSelector((state) => state.userReducer.user?.userType);

  const handleDeleteButtonClick = () => {
    confirm({
      title: t("Підтвердити видалення"),
      okText: t("Видалити"),
      okType: "danger",
      cancelText: t("Скасувати"),
      onOk: handleDelete,
    });
  };

  const handleDelete = async () => {
    try {
      setDeleteLoading(true);
      await CasesApi.delete(medCase.caseUUID);
      onDelete(medCase.caseUUID);
    } catch (e: any) {
      notification.error({
        message: e.message,
      });
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <Space className="table-actions" direction="vertical">
      <Button
        size="small"
        icon={<EyeOutlined />}
        onClick={(e) => {
          e.stopPropagation();
          onWatchClick(medCase);
        }}
      />
      <Button
        size="small"
        icon={<EditOutlined />}
        onClick={() => onEditButtonClick(medCase)}
      />
      {userType?.userTypeUUID !== UserTypeEnum["Client's employee"] && (
        <Button
          size="small"
          icon={<DeleteOutlined />}
          loading={deleteLoading}
          danger
          onClick={handleDeleteButtonClick}
        />
      )}
    </Space>
  );
};

export default CasesTableActions;
